import { Box, Button, Divider, Stack } from "@mui/material";
import TopHeadingDividerComponent from "../AccountSetting/TopHeadingDividerComponent";
import SaveChangingsButton from "../AccountSetting/SaveChangingsButton";
const privacyAndSafetyData = [
  {
    primary: "Use two-factor authentication",
    secondary:
      "Unaffected occasional thoroughly. Adieus it no wonders spirit houses.",
    btnText: "Change",
  },
  {
    primary: "Login activity",
    secondary: "Ask a quick six seven offer see among.",
    btnText: "View",
  },
  {
    primary: "Manage your data and activity",
    secondary: "Ask a quick six seven offer see among.",
    btnText: "Change",
  },
  {
    primary: "Search history",
    secondary: "Selct a language for translation",
    btnText: "Change",
  },
  {
    primary: "Permitted services",
    secondary: "Choose if this feature appears on your profile",
    btnText: "Change",
  },
];
function PrivacyAndSafetySection() {
  return (
    <Stack
      sx={{
        bgcolor: "#ffffff",
        p: "20px",
        borderRadius: "20px",
        pb: "100px",
      }}
    >
      <TopHeadingDividerComponent
        primary="Privacy & Safety"
        secondary="See information about your account, download an archive of your data, or learn about your account deactivation options"
      />
      <Stack spacing={3} sx={{ pt: "12px", pb: "14px" }}>
        {privacyAndSafetyData.map((data) => (
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <TopHeadingDividerComponent
                primary={data.primary}
                secondary={data.secondary}
                divider={false}
                primaryFontSize="18px"
                primaryLineHeight="21.78px"
                secondaryBottomPadding="0px"
              />
            </Box>{" "}
            <Button
              variant="contained"
              startIcon={
                <Box
                  component="img"
                  src="/icons/writeIcon.svg"
                  sx={{ width: "18px", height: "18.11px" }}
                ></Box>
              }
              sx={{
                width: "120px",
                py: "4px",
                alignSelf: "start",
                borderRadius: "20.5px",
                px: "22px",
                // minWidth: "auto",
                // width: "auto",
                textTransform: "none",
                bgcolor: "transparent",
                color: "#000000",
                boxShadow: "none",
                border: "1px solid #000000",
                "&:hover": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:active": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:focus": {
                  outline: "none",
                  boxshadow: "none",
                },
                "& .MuiButtonBase-root": {
                  width: "auto !important",
                  minWidth: "0px !important",
                  padding: "0px",
                  boxshadow: "none",
                },
              }}
            >
              {data.btnText}
            </Button>
          </Stack>
        ))}
        <Divider
          sx={{
            height: "1px",
            bgcolor: "#EBEBEB",
            border: "none",
            mx: "-20px",
            my: "16px",
          }}
        />
      </Stack>
      <SaveChangingsButton alignSelf="end">Save Changings</SaveChangingsButton>
    </Stack>
  );
}

export default PrivacyAndSafetySection;
